(function($) {
  'use strict';

  if (!$) {
    return;
  }

  function focusSearchInput(input, preserveId) {
    if (!input.length) {
      return;
    }

    if (!preserveId) {
      input.attr('id', 'bc-product-search');
    }

    input.trigger('focus');

    try {
      input[0].focus({ preventScroll: true });
      input[0].setSelectionRange(input.val().length, input.val().length);
    } catch (error) {
      input[0].focus();
    }

    setTimeout(function() {
      input.trigger('focus');
      try {
        input[0].focus({ preventScroll: true });
      } catch (error) {
        input[0].focus();
      }
    }, 50);
  }

  function focusBoostMobileInput() {
    var boostInput = $('#boost-pfs-search-box-mobile');

    if (!boostInput.length || !boostInput.is(':visible')) {
      return false;
    }

    focusSearchInput(boostInput, true);
    $('html, body').removeClass('boost-search-launching').addClass('boost-search-open');
    return true;
  }

  function hideLauncherAfterKeyboardCue() {
    var hideLauncher = function() {
      $('html, body').removeClass('boost-keyboard-cue').addClass('boost-search-launching');
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(hideLauncher);
      });
      return;
    }

    setTimeout(hideLauncher, 32);
  }

  function closeSearchLauncher() {
    $('.search-drawer-target').removeClass('show');
    $('html, body').removeClass('search-opened boost-search-launching boost-search-open boost-keyboard-cue');
    $('body').removeClass('boost-pfs-search-suggestion-mobile-open popup-is-showing');
    $('.boost-pfs-search-suggestion-wrapper').removeClass('boost-pfs-search-suggestion-open').hide();
    $('.boost-pfs-search-suggestion-mobile-overlay').hide();
    $('.boost-pfs-search-suggestion-mobile-top-panel').hide();
    $('.cart-dd').css('pointer-events', '');

    if (window.AT_Main && typeof window.AT_Main.fixReturnScroll === 'function') {
      window.AT_Main.fixReturnScroll();
    }
  }

  $(document).on('mousedown touchstart', '.search-drawer > a', function(event) {
    event.preventDefault();
  });

  $(document).on('click', '.search-drawer', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var drawer = $('.search-drawer-target');
    var searchInput = drawer.find('input[name="q"]').first();

    $('.cart-target').removeClass('opened');
    $('html, body').removeClass('cart-opened boost-search-open boost-search-launching').addClass('search-opened boost-keyboard-cue');
    $('.cart-dd').css('pointer-events', 'none');

    drawer.addClass('show');

    if (window.AT_Main && typeof window.AT_Main.fixNoScroll === 'function') {
      window.AT_Main.fixNoScroll();
    }

    focusSearchInput(searchInput);
    hideLauncherAfterKeyboardCue();

    setTimeout(focusBoostMobileInput, 100);
    setTimeout(focusBoostMobileInput, 300);
    setTimeout(focusBoostMobileInput, 700);
    setTimeout(focusBoostMobileInput, 1200);
  });

  $(document).on('click', '.search-drawer-content .close', function() {
    closeSearchLauncher();
  });

  $(document).on('click', '.boost-pfs-search-suggestion-mobile-top-panel button, .boost-pfs-search-suggestion-mobile-top-panel .boost-pfs-search-btn-close', function() {
    setTimeout(function() {
      if (!$('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open').length) {
        closeSearchLauncher();
      }
    }, 150);
  });

  $(document).on('click touchend', '.boost-pfs-search-suggestion-mobile-overlay', function(event) {
    event.preventDefault();
    closeSearchLauncher();
  });
})(window.jQuery);
